import { Toastr } from "../../../revvComponents";
import { addDocumentComponentService } from "../../../actions/DocumentActions/services";
import DocTemplateBaseCommand from "./docTemplateBaseCommand";

import { DOCUMENTS } from "../../../constants";
import { DOCUMENT_MODE } from "../../../constants/document";

const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class AddDocComponentCommand extends DocTemplateBaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  saveToDatabase(componentPayload) {
    const { docNo, docID, component } = this.componentData;
    return new Promise((resolve, reject) => {
      if (component.type === DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER) {
        this.componentData.updateAddComponentinToolbarAction(
          DOCUMENT_COMPONENT_TYPES.HEADER_FOOTER,
        );
      }
      if (component.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
        this.componentData.autoUpdateTitle(DOCUMENT_MODE.DOCUMENT, docID);
      }

      addDocumentComponentService(docNo || docID, [componentPayload])
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          console.error(`Document => _addNewComponent => Error : ${error}`);
          Toastr.showToastr({
            type: "failure",
            message: "Oops, Something went wrong!!",
            timeout: 3000,
          });
          setTimeout(() => {
            this.componentData.deleteDocumentComponentAction(component.id);
          }, 2000);
          reject(error);
        });
    });
  }

  execute() {
    super.execute();
    if (!this.isRedo) {
      // 4.
      const componentPayload = super.getComponentPayload();
      // 5.
      this.saveToDatabase(componentPayload)
        .then(() => {})
        .catch(() => {});
    }
  }

  undo() {
    super.undo();
  }
}

export default AddDocComponentCommand;
